export const translations = {
  en: {
    nav: {
      tours: "Tours",
      about: "About",
      clientStories: "Client Stories",
      contact: "Contact",
      faq: "FAQ",
      bookNow: "Book Now",
    },
    hero: {
      title: "Azur Escape",
      subtitle: "Exclusive guided tours of the Côte d'Azur",
      description:
        "Experience the glamour, culture, and natural beauty of the French Riviera with our personalized private tours. From Monaco's luxury to charming medieval villages, create unforgettable memories.",
      ctaButton: "Explore Tours",
      ctaWhatsapp: "Book via WhatsApp",
    },
    tours: {
      title: "Our Tours",
      subtitle: "Carefully curated experiences of the French Riviera",
      topPick: "Top Pick",
      from: "From",
      perPerson: "per person",
      duration: "Duration",
      departure: "Departure",
      highlights: "Highlights",
      viewDetails: "View Details",
      bookTour: "Book This Tour",
      pricing: {
        title: "Tour Pricing",
        subtitle: "All tours available at the same competitive rates",
      },
      // Badge labels (shared between TourCard and TourHeroSection)
      badges: {
        topPick: "Top Pick",
        popular: "Popular 🔥",
        private: "Private",
        privateTour: "Private Tour",
      },
      // Tour card UI strings
      card: {
        halfDay: "Half Day",
        fullDay: "Full Day",
        departureLabel: "Departure:",
        highlightsLabel: "Highlights:",
        person: "person",
        customRoute: "Custom route",
        details: "Details",
        startingFrom: "Starting from",
        totalPrice: "Total Price",
      },
      // Section header on the home page
      section: {
        title: "Discover Our Tours",
        subtitle:
          "From half-day adventures to full-day explorations, find your perfect French Riviera experience",
      },
      // Custom tour CTA block
      custom: {
        title: "Need a Custom Experience?",
        description:
          "Contact us to create a personalized tour tailored to your interests, schedule, and preferences.",
        cta: "Contact Us on WhatsApp",
      },
    },
    about: {
      title: "About Azur Escape",
      subtitle: "Your Gateway to the French Riviera",
      description:
        "We are passionate local guides who know every hidden gem of the Côte d'Azur. Our personalized tours combine luxury, culture, and authentic experiences to create unforgettable memories.",
      whyChooseUs: "Why Choose Us",
      reasons: {
        local: {
          title: "Local Expertise",
          description:
            "Born and raised on the French Riviera, we share insider knowledge and hidden gems.",
        },
        personalized: {
          title: "Personalized Service",
          description:
            "Every tour is tailored to your interests, pace, and preferences.",
        },
        luxury: {
          title: "Luxury Experience",
          description:
            "Travel in comfort with premium vehicles and exclusive access to special locations.",
        },
        authentic: {
          title: "Authentic Moments",
          description:
            "We create genuine connections with local culture, cuisine, and traditions.",
        },
      },
      clientsButton: "Meet Our Clients",
    },
    testimonials: {
      title: "Client Memories",
      subtitle: "Stories from our French Riviera adventures",
      readMore: "Read More",
      readLess: "Read Less",
      previous: "Previous",
      next: "Next",
      close: "Close",
    },
    contact: {
      title: "Contact Us",
      subtitle: "Ready to explore the French Riviera?",
      getInTouch: "Get in Touch",
      name: "Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send Message",
      whatsappTitle: "WhatsApp",
      whatsappDescription: "Quick booking and instant responses",
      phoneTitle: "Phone",
      phoneDescription: "Speak directly with our team",
      emailTitle: "Email",
      emailDescription: "Detailed inquiries and information",
    },
    footer: {
      tagline: "Discover the French Riviera with Azur Escape",
      quickLinks: "Quick Links",
      contact: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved.",
      home: "Home",
      tours: "Tours",
      about: "About",
      testimonials: "Testimonials",
    },
    tourDetails: {
      overview: "Overview",
      itinerary: "Itinerary",
      pricing: "Pricing",
      bookNow: "Book Now",
      highlights: "Highlights",
      duration: "Duration",
      departure: "Departure",
      includes: "Includes",
      excludes: "Excludes",
      notes: "Important Notes",
      whatsappBooking: "Book via WhatsApp",
      backToTours: "Back to Tours",
      // Navigation
      back: "Back",
      // Quick-info grid
      info: "Tour Information",
      frequency: "Frequency",
      stops: "Stops",
      tourStops: "Tour Stops",
      // 404 state
      notFound: {
        title: "Tour Not Found",
        description:
          "The tour you're looking for doesn't exist or may have been removed.",
        cta: "Browse All Tours",
      },
      // Private tour benefits panel
      privateBenefits: {
        title: "Private Tour Benefits",
        flexible: "Flexible itinerary customized to your interests",
        personalGuide: "Personal dedicated guide",
        pickup: "Pickup from your location",
        vehicle: "Premium comfort vehicle",
      },
      // Booking sidebar
      booking: {
        title: "Book This Tour",
        pricePerPerson: "Price per person",
        totalPriceLabel: "Total Price",
        flatRate: "(Flat rate for the tour)",
        numberOfPeople: "Number of People",
        person: "person",
        people: "people",
        privateFlatRate: "Private tour (flat rate)",
        groupDiscount: "Group Discount (10%)",
        discountNudge:
          "Book for 4+ people and get 10% group discount!",
        bookWhatsapp: "Book on WhatsApp",
        questions: "Questions? Contact us:",
        startingFrom: "Starting from",
      },
    },
    clientMemories: {
      title: "Client Memories",
      subtitle: "Discover the French Riviera through our clients' eyes",
      description:
        "Every tour creates unique memories. Here are some of our favorite moments shared with wonderful people from around the world.",
      memoriesGallery: "Memories Gallery",
      clientStories: "Client Stories",
      showAll: "Show All",
      filterByRating: "Filter by Rating",
      stars: "stars",
    },
    aboutPreview: {
      badge: "Born on the French Riviera",
      titleLine1: "Your Authentic French Riviera",
      titleHighlight: "Experience",
      description: "We're not just tour guides – we're your local friends who happen to know every hidden gem, secret viewpoint, and authentic experience the French Riviera has to offer. Born and raised here, we share our home with you the way we'd show our own family.",
      rating: "5/5 Rating",
      happyTravelers: "1,000+ Happy Travelers",
      countries: "25+ Countries",
      recommendation: "Recommendation",
      whyChoose: "Why Choose Azur Escape?",
      trustFeatures: {
        licensedTitle: "Licensed & Insured",
        licensedDesc: "Fully certified local guides with insurance coverage",
        smallGroupsTitle: "Small Groups Only",
        smallGroupsDesc: "Maximum 8 people for personalized experiences",
        localTitle: "Local Expertise",
        localDesc: "Born and raised on the French Riviera",
        multilingualTitle: "Multilingual Guides",
        multilingualDesc: "English & French",
      },
      whatTravelersSay: "What Our Travelers Say",
      travelersSubtitle: "Don't just take our word for it. Here's what recent guests have to say about their French Riviera experiences.",
      adventureTitle: "Ready for Your French Riviera Adventure?",
      adventureSubtitle: "Let's create memories that will last a lifetime. Contact us to start planning your personalized tour today.",
      ctaWhatsapp: "Start Planning on WhatsApp",
      ctaPhone: "Call +33 7 58 78 16 78",
    },
    contactSection: {
      title: "Ready to Explore the French Riviera?",
      subtitle: "Get in touch to book your personalized tour or ask any questions. I'm here to help you create unforgettable memories along the Mediterranean coast.",
      getInTouch: "Get In Touch",
      whatsappTitle: "WhatsApp (Preferred)",
      whatsappDesc: "Quick responses, instant booking",
      emailTitle: "Email",
      emailDesc: "For detailed inquiries",
      basedIn: "Based In",
      basedInDesc: "Tours throughout the French Riviera",
      basedInLocation: "Nice, Côte d'Azur, France",
      followAdventures: "Follow Our Adventures",
      tourAreas: "Our Tour Areas",
      readyToBook: "Ready to Book?",
      readyToBookDesc: "Click below to start a WhatsApp conversation and book your tour instantly!",
      bookNowWhatsapp: "Book Now on WhatsApp",
      trustLicensed: "Licensed Tour Guide",
      trustInsured: "Fully Insured",
      trustCovid: "COVID-19 Safety Protocols",
      trustSmallGroup: "Small Group Guarantee",
    },
    footerSection: {
      brandDesc: "Your trusted local guide for unforgettable French Riviera experiences. Discover hidden gems, iconic landmarks, and authentic culture with personalized tours.",
      quickLinks: "Quick Links",
      ourTours: "Our Tours",
      aboutUs: "About Us",
      clientStories: "Client Stories",
      contact: "Contact",
      faq: "FAQ",
      privacyPolicy: "Privacy Policy",
      contactInfo: "Contact Info",
      languages: "3 Languages: FR, EN, AR",
      madeWith: "Made with",
      forTravelers: "for French Riviera travelers.",
      licensedLine: "Licensed tour guide | Fully insured | Small group experiences",
    },
    whatsapp: {
      onlineNow: "Online now",
      greeting: "Hi! 👋 How can we help you today?",
      bookTour: "Book a Tour",
      bookTourMsg: "Hello! I'm interested in booking a French Riviera tour. Could you please provide more information about availability and pricing?",
      askQuestions: "Ask Questions",
      askQuestionsMsg: "Hi! I have some questions about your French Riviera tours. Could you help me?",
      customTour: "Custom Tour",
      customTourMsg: "Hello! I'm interested in a custom/private tour of the French Riviera. Can we discuss the options?",
      groupBooking: "Group Booking",
      groupBookingMsg: "Hi! I need to book a tour for a group. Could you provide information about group rates and availability?",
      replyTime: "Typically replies in a few minutes",
    },
    testimonialsPage: {
      title: "Memories Made Together",
      subtitle: "Discover authentic experiences through the eyes of our guests. Explore their photos and stories from the French Riviera.",
      avgRating: "Average Rating",
      happyTravelers: "Happy Travelers",
      countries: "Countries",
      satisfaction: "Satisfaction",
      photoGallery: "Client Photo Gallery",
      clickPhoto: "Click on any photo to see their story",
      readyTitle: "Ready to Create Your Story?",
      readySubtitle: "Join our happy travelers!",
      startAdventure: "Start Your Adventure",
    },
    common: {
      loading: "Loading...",
      error: "An error occurred",
      retry: "Retry",
      close: "Close",
      next: "Next",
      previous: "Previous",
      showMore: "Show More",
      showLess: "Show Less",
    },
  },

  fr: {
    nav: {
      tours: "Tours",
      about: "À propos",
      clientStories: "Témoignages",
      contact: "Contact",
      faq: "FAQ",
      bookNow: "Réserver",
    },
    hero: {
      title: "Azur Escape",
      subtitle: "Visites guidées exclusives de la Côte d'Azur",
      description:
        "Découvrez le glamour, la culture et la beauté naturelle de la Côte d'Azur avec nos tours privés personnalisés. Du luxe de Monaco aux charmants villages médiévaux, créez des souvenirs inoubliables.",
      ctaButton: "Explorer les Tours",
      ctaWhatsapp: "Réserver via WhatsApp",
    },
    tours: {
      title: "Nos Tours",
      subtitle: "Expériences soigneusement sélectionnées de la Côte d'Azur",
      topPick: "Coup de Cœur",
      from: "À partir de",
      perPerson: "par personne",
      duration: "Durée",
      departure: "Départ",
      highlights: "Points forts",
      viewDetails: "Voir les détails",
      bookTour: "Réserver ce Tour",
      pricing: {
        title: "Tarifs des Circuits",
        subtitle: "Tous les circuits disponibles aux mêmes tarifs compétitifs",
      },
      badges: {
        topPick: "Meilleur Choix",
        popular: "Populaire 🔥",
        private: "Privé",
        privateTour: "Tour Privé",
      },
      card: {
        halfDay: "Demi-journée",
        fullDay: "Journée complète",
        departureLabel: "Départ:",
        highlightsLabel: "Points forts:",
        person: "personne",
        customRoute: "Itinéraire personnalisé",
        details: "Détails",
        startingFrom: "À partir de",
        totalPrice: "Prix total",
      },
      section: {
        title: "Découvrez Nos Circuits",
        subtitle:
          "Des aventures d'une demi-journée aux explorations d'une journée complète, trouvez votre expérience parfaite sur la Côte d'Azur",
      },
      custom: {
        title: "Besoin d'une expérience personnalisée?",
        description:
          "Contactez-nous pour créer un circuit personnalisé adapté à vos intérêts, votre emploi du temps et vos préférences.",
        cta: "Contactez-nous sur WhatsApp",
      },
    },
    about: {
      title: "À propos d'Azur Escape",
      subtitle: "Votre passerelle vers la Côte d'Azur",
      description:
        "Nous sommes des guides locaux passionnés qui connaissent chaque joyau caché de la Côte d'Azur. Nos tours personnalisés combinent luxe, culture et expériences authentiques pour créer des souvenirs inoubliables.",
      whyChooseUs: "Pourquoi nous choisir",
      reasons: {
        local: {
          title: "Expertise locale",
          description:
            "Nés et élevés sur la Côte d'Azur, nous partageons nos connaissances privilégiées et nos joyaux cachés.",
        },
        personalized: {
          title: "Service personnalisé",
          description:
            "Chaque tour est adapté à vos intérêts, votre rythme et vos préférences.",
        },
        luxury: {
          title: "Expérience de luxe",
          description:
            "Voyagez confortablement avec des véhicules premium et un accès exclusif à des lieux spéciaux.",
        },
        authentic: {
          title: "Moments authentiques",
          description:
            "Nous créons des connexions genuines avec la culture, la cuisine et les traditions locales.",
        },
      },
      clientsButton: "Rencontrer nos clients",
    },
    testimonials: {
      title: "Souvenirs clients",
      subtitle: "Histoires de nos aventures sur la Côte d'Azur",
      readMore: "Lire plus",
      readLess: "Lire moins",
      previous: "Précédent",
      next: "Suivant",
      close: "Fermer",
    },
    contact: {
      title: "Nous contacter",
      subtitle: "Prêt à explorer la Côte d'Azur ?",
      getInTouch: "Contactez-nous",
      name: "Nom",
      email: "Email",
      phone: "Téléphone",
      message: "Message",
      send: "Envoyer le message",
      whatsappTitle: "WhatsApp",
      whatsappDescription: "Réservation rapide et réponses instantanées",
      phoneTitle: "Téléphone",
      phoneDescription: "Parlez directement avec notre équipe",
      emailTitle: "Email",
      emailDescription: "Demandes détaillées et informations",
    },
    footer: {
      tagline: "Découvrez la Côte d'Azur avec Azur Escape",
      quickLinks: "Liens rapides",
      contact: "Contact",
      followUs: "Suivez-nous",
      rights: "Tous droits réservés.",
      home: "Accueil",
      tours: "Tours",
      about: "À propos",
      testimonials: "Témoignages",
    },
    tourDetails: {
      overview: "Aperçu",
      itinerary: "Itinéraire",
      pricing: "Tarifs",
      bookNow: "Réserver maintenant",
      highlights: "Points forts",
      duration: "Durée",
      departure: "Départ",
      includes: "Inclus",
      excludes: "Exclus",
      notes: "Notes importantes",
      whatsappBooking: "Réserver via WhatsApp",
      backToTours: "Retour aux tours",
      back: "Retour",
      info: "Informations sur le circuit",
      frequency: "Fréquence",
      stops: "Arrêts",
      tourStops: "Arrêts du circuit",
      notFound: {
        title: "Circuit introuvable",
        description:
          "Le circuit que vous recherchez n'existe pas ou a peut-être été supprimé.",
        cta: "Voir tous les circuits",
      },
      privateBenefits: {
        title: "Avantages du tour privé",
        flexible: "Itinéraire flexible personnalisé selon vos intérêts",
        personalGuide: "Guide personnel dédié",
        pickup: "Prise en charge depuis votre emplacement",
        vehicle: "Véhicule confortable premium",
      },
      booking: {
        title: "Réserver ce circuit",
        pricePerPerson: "Prix par personne",
        totalPriceLabel: "Prix total",
        flatRate: "(Tarif forfaitaire pour le circuit)",
        numberOfPeople: "Nombre de personnes",
        person: "personne",
        people: "personnes",
        privateFlatRate: "Tour privé (tarif forfaitaire)",
        groupDiscount: "Remise de groupe (10%)",
        discountNudge:
          "Réservez pour 4+ personnes et obtenez 10% de réduction de groupe!",
        bookWhatsapp: "Réserver sur WhatsApp",
        questions: "Des questions? Contactez-nous:",
        startingFrom: "À partir de",
      },
    },
    clientMemories: {
      title: "Souvenirs clients",
      subtitle: "Découvrez la Côte d'Azur à travers les yeux de nos clients",
      description:
        "Chaque tour crée des souvenirs uniques. Voici quelques-uns de nos moments préférés partagés avec des personnes merveilleuses du monde entier.",
      memoriesGallery: "Galerie des souvenirs",
      clientStories: "Témoignages clients",
      showAll: "Tout afficher",
      filterByRating: "Filtrer par note",
      stars: "étoiles",
    },
    aboutPreview: {
      badge: "Né sur la Côte d'Azur",
      titleLine1: "Votre authentique expérience",
      titleHighlight: "Côte d'Azur",
      description: "Nous ne sommes pas de simples guides touristiques – nous sommes vos amis locaux qui connaissent chaque joyau caché, chaque point de vue secret et chaque expérience authentique que la Côte d'Azur a à offrir. Nés et élevés ici, nous partageons notre maison avec vous comme nous le ferions avec notre propre famille.",
      rating: "5/5 Note",
      happyTravelers: "1,000+ Voyageurs satisfaits",
      countries: "25+ Pays",
      recommendation: "Recommandation",
      whyChoose: "Pourquoi choisir Azur Escape ?",
      trustFeatures: {
        licensedTitle: "Licencié & Assuré",
        licensedDesc: "Guides locaux certifiés avec couverture d'assurance",
        smallGroupsTitle: "Petits groupes uniquement",
        smallGroupsDesc: "Maximum 8 personnes pour des expériences personnalisées",
        localTitle: "Expertise locale",
        localDesc: "Nés et élevés sur la Côte d'Azur",
        multilingualTitle: "Guides multilingues",
        multilingualDesc: "Anglais et français",
      },
      whatTravelersSay: "Ce que disent nos voyageurs",
      travelersSubtitle: "Ne nous croyez pas sur parole. Voici ce que nos récents clients disent de leurs expériences sur la Côte d'Azur.",
      adventureTitle: "Prêt pour votre aventure sur la Côte d'Azur ?",
      adventureSubtitle: "Créons des souvenirs qui dureront toute une vie. Contactez-nous pour commencer à planifier votre visite personnalisée dès aujourd'hui.",
      ctaWhatsapp: "Planifier sur WhatsApp",
      ctaPhone: "Appeler +33 7 58 78 16 78",
    },
    contactSection: {
      title: "Prêt à explorer la Côte d'Azur ?",
      subtitle: "Contactez-nous pour réserver votre visite personnalisée ou poser vos questions. Je suis là pour vous aider à créer des souvenirs inoubliables le long de la côte méditerranéenne.",
      getInTouch: "Contactez-nous",
      whatsappTitle: "WhatsApp (Préféré)",
      whatsappDesc: "Réponses rapides, réservation instantanée",
      emailTitle: "Email",
      emailDesc: "Pour les demandes détaillées",
      basedIn: "Basé à",
      basedInDesc: "Circuits dans toute la Côte d'Azur",
      basedInLocation: "Nice, Côte d'Azur, France",
      followAdventures: "Suivez nos aventures",
      tourAreas: "Nos zones de circuits",
      readyToBook: "Prêt à réserver ?",
      readyToBookDesc: "Cliquez ci-dessous pour démarrer une conversation WhatsApp et réserver votre circuit instantanément !",
      bookNowWhatsapp: "Réserver sur WhatsApp",
      trustLicensed: "Guide touristique licencié",
      trustInsured: "Entièrement assuré",
      trustCovid: "Protocoles de sécurité COVID-19",
      trustSmallGroup: "Garantie petit groupe",
    },
    footerSection: {
      brandDesc: "Votre guide local de confiance pour des expériences inoubliables sur la Côte d'Azur. Découvrez des joyaux cachés, des monuments emblématiques et une culture authentique avec des visites personnalisées.",
      quickLinks: "Liens rapides",
      ourTours: "Nos circuits",
      aboutUs: "À propos",
      clientStories: "Témoignages",
      contact: "Contact",
      faq: "FAQ",
      privacyPolicy: "Politique de confidentialité",
      contactInfo: "Informations de contact",
      languages: "3 Langues : FR, EN, AR",
      madeWith: "Fait avec",
      forTravelers: "pour les voyageurs de la Côte d'Azur.",
      licensedLine: "Guide licencié | Entièrement assuré | Expériences en petit groupe",
    },
    whatsapp: {
      onlineNow: "En ligne",
      greeting: "Bonjour ! 👋 Comment pouvons-nous vous aider ?",
      bookTour: "Réserver un circuit",
      bookTourMsg: "Bonjour ! Je souhaite réserver un circuit sur la Côte d'Azur. Pourriez-vous me donner plus d'informations sur les disponibilités et les tarifs ?",
      askQuestions: "Poser des questions",
      askQuestionsMsg: "Bonjour ! J'ai quelques questions sur vos circuits sur la Côte d'Azur. Pourriez-vous m'aider ?",
      customTour: "Circuit personnalisé",
      customTourMsg: "Bonjour ! Je suis intéressé par un circuit personnalisé/privé sur la Côte d'Azur. Pouvons-nous en discuter ?",
      groupBooking: "Réservation de groupe",
      groupBookingMsg: "Bonjour ! Je souhaite réserver un circuit pour un groupe. Pourriez-vous me donner des informations sur les tarifs de groupe et les disponibilités ?",
      replyTime: "Répond généralement en quelques minutes",
    },
    testimonialsPage: {
      title: "Souvenirs créés ensemble",
      subtitle: "Découvrez des expériences authentiques à travers les yeux de nos invités. Explorez leurs photos et histoires de la Côte d'Azur.",
      avgRating: "Note moyenne",
      happyTravelers: "Voyageurs satisfaits",
      countries: "Pays",
      satisfaction: "Satisfaction",
      photoGallery: "Galerie photos clients",
      clickPhoto: "Cliquez sur une photo pour voir leur histoire",
      readyTitle: "Prêt à créer votre histoire ?",
      readySubtitle: "Rejoignez nos voyageurs satisfaits !",
      startAdventure: "Commencer votre aventure",
    },
    common: {
      loading: "Chargement...",
      error: "Une erreur s'est produite",
      retry: "Réessayer",
      close: "Fermer",
      next: "Suivant",
      previous: "Précédent",
      showMore: "Afficher plus",
      showLess: "Afficher moins",
    },
  },
};
